   <fn-modal-header class="modal-header">
  <h5 class="modal-title" mat-dialog-title>Alert History</h5>
  <button
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
    (click)="close()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</fn-modal-header>
<mat-dialog-content class="p-15">
  <div class="row">
    <div class="col-12">
      @if(commentArr.length > 0){
      <div class="commentSection">
        <div class="comments" *ngFor="let obj of commentArr">
          <div class="d-flex justify-content-between align-items-start">
            <div class="d-flex justify-content-start width-35 gap-2">
              <div class="media-shortName">{{ obj.shortName }}</div>
              <div class="commentedby">
                {{ obj.commentedBy }}
                <p
                  class="mb-0 width-450px text-truncate"
                  title="{{ obj.commentText }}"
                >
                  {{ obj.commentText }}
                </p>
              </div>
             
            </div>
            <div class="action">
              <span
                class="cmnt btn text-center"
                [ngClass]="{
                  'btn-outline-primary': obj.action == 'Comment',
                  'btn-outline-warning': obj.action == 'Forward',
                  'btn-outline-danger': obj.action == 'Auto Escalated' || obj.action == 'Alert Disabled' || obj.action == 'Severity Increased',
                  'btn-outline-success': obj.action == 'Enabled Alert' || obj.action == 'Resolve',
                  'btn-outline-info': obj.action == 'Acknowledged',
                  'btn-outline-dark': obj.action == 'Escalate',
                  'btn-outline-secondary': obj.action == 'Severity Change',
                }"
              >
                {{ obj.action }}</span
              >
            </div>
            <div class="commentAt">
              <label class="m-0">{{ obj.commentedAt }}</label>
            </div>
          </div>
        </div>
      </div>
      } @if(commentArr.length === 0){
      <fn-no-data-box
        [showImg]="true"
        [imgContainerheight]="'500'"
        [isVerticalImg]="false"
      >
      </fn-no-data-box>
      }
    </div>
  </div>
</mat-dialog-content>
